import { ComponentProps, PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";

import FormAccordion from "@components/accordions/FormAccordion";
import BodyCopy from "@components/typography/BodyCopy";

type Props = PropsWithChildren<{
  color: ComponentProps<typeof FormAccordion>["color"];
  defaultOpen?: boolean;
  sectionName: string;
}>;

const CareProfileSection = ({ children, color, defaultOpen = false, sectionName }: Props) => (
  <div className="margin-10-bottom">
    <FormAccordion
      color={color}
      content={children}
      defaultOpen={defaultOpen}
      heading={
        <BodyCopy bold>
          <FormattedMessage id={`pages.careProfile.sectionTitles.${sectionName}`} />
        </BodyCopy>
      }
    />
  </div>
);

export default CareProfileSection;
